import { useReducer } from "react";
import workshopReducer from "./workshopReducer";
import workshopContext from "./workshopContext";

export default function WorkshopState({ children }) {
 
    const [state, dispatch] = useReducer(workshopReducer, {
        workshops: []
    });

    const setWorkshops = (workshops, orderBy) => {
        if (orderBy != null) {
            if (orderBy === "distance") {
                console.log("here");
                workshops.sort((a, b) => a.distance - b.distance);
            }
        }

        // Before sending to context, add new parameter orderNr to each workshop
        workshops = workshops.map((workshop, index) => ({
            ...workshop,
            orderNr: index + 1
        }));
        dispatch({ type: "SET_WORKSHOPS", payload: workshops });
    };

    const emptySelectedWorkshops = () => {
        dispatch({ type: "EMPTY_WORKSHOPS" });
    };

    const selectWorkshopForMap = (workshop) => {
        dispatch({ type: "SELECT_WORKSHOP", payload: workshop });
    }

    const emptySelectedWorkshopForMap = () => {
        dispatch({ type: "EMPTY_SELECTED_WORKSHOP" });
    }

    return (
        <workshopContext.Provider value={{ state, setWorkshops, emptySelectedWorkshops, selectWorkshopForMap, emptySelectedWorkshopForMap }}>
        {children}
        </workshopContext.Provider>
    );
}